import React, {useEffect, useState} from 'react';
import {Alert, FormControl, FormGroup, InputGroup, Modal} from 'react-bootstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const CopyLinkContainer = ({ link }) => {
    try {
        const [ copied, set_copied ] = useState(false); 

        return (
            <>
                <FormGroup>
                    <InputGroup>
                        <FormControl type="text" value={link}/>
                        <InputGroup.Addon>
                            <CopyToClipboard 
                                text={link}
                                onCopy={() => set_copied(true)}
                            >
                                <span style={{ cursor: 'pointer' }} className="fa fa-copy" />
                            </CopyToClipboard>
                        </InputGroup.Addon>
                    </InputGroup>
                </FormGroup>
                {copied ? (
                    <Alert bsStyle="success" className="text-center">
                        <span className="fa fa-2x fa-check"/> <br /><strong>Link copied to clipboard</strong>
                    </Alert>
                ): ''}
            </>
        )
    } catch (err) {
        console.log('error in CopyLinkContainer -->>', err);
        return '';
    }
}

export default CopyLinkContainer